import type { ChannelPreviewUIComponentProps } from 'stream-chat-react';
import { useChatContext } from 'stream-chat-react';
import { StreamChatAvatar } from './StreamChatAvatar';

type DirectMessagingChannelPreviewProps = Pick<ChannelPreviewUIComponentProps, 'channel'>;

export const DirectMessagingChannelPreview = ({ channel }: DirectMessagingChannelPreviewProps) => {
	const { client } = useChatContext();

	const members = Object.values(channel.state.members).filter(({ user }) => user?.id !== client.userID);
	const defaultName = 'Unknown User';
	let displayText;
	let avatars;

	if (!members.length || members.length === 1) {
		const member = members[0];
		displayText = member?.user?.name || member?.user?.id || defaultName;
		avatars = <StreamChatAvatar image={member?.user?.image} name={member?.user?.name || member?.user?.id} />;
	} else {
		displayText = members.map((member) => member?.user?.name || member?.user?.id || defaultName).join(', ');
		const additionalMemberCount = members.length - 2;
		avatars = (
			<>
				<StreamChatAvatar image={members[0]?.user?.image} name={members[0]?.user?.name || members[0]?.user?.id} />
				<StreamChatAvatar
					className="!absolute left-2 top-0"
					image={members[1]?.user?.image}
					name={members[1]?.user?.name || members[1]?.user?.id}
				/>
				{additionalMemberCount > 0 && (
					<div className="absolute top-0 left-4 w-8 h-8 p-1 bg-gray-200 rounded-full border-2 border-gray-500">
						+{additionalMemberCount}
					</div>
				)}
			</>
		);
	}

	return (
		<div className="flex gap-2 items-center" title={displayText}>
			<div className="relative w-16">{avatars}</div>
			<p className="truncate">{displayText}</p>
		</div>
	);
};
